import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
})
export class RadioButtonComponent implements OnInit {
  @Input() name: string = '';
  @Input() value: any;
  @Input() selectedValue: any;
  @Input() disabled: boolean = false;
  @Input() label: string = '';
  @Input() btnId: string = '';
  @Input() styleClassLabel: string = '';
  @Input() labelColor: string = '';
  @Input() position: string = 'end'; // [start, end]
  @Input() imgIcon = null;
  @Input() imgIconClass: string = '';

  @Output() appChange = new EventEmitter<any>();

  focusClass: string = '';

  constructor() {}

  ngOnInit() {}

  onChange(event?) {
    this.appChange.emit(this.value);
  }
}
